if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"sudoku_angular","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(default\-webpack_sharing_consume_default_(angular_co(mmon_angular_common|re_angular_core)|cv\-mf_(angular\-(context\-store_cv\-mf_angular\-context\-store|field\-store_cv\-mf_angular\-field\-store\-w\-cf2295)|sudoku\-(services_cv\-mf_sudoku\-servic|types_cv\-mf_sudoku\-typ)es))|runtime)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}